module.exports = __webpack_public_path__ + "static/media/phone-call.939a1c61.svg";